import { render, staticRenderFns } from "./half_loc_cards.vue?vue&type=template&id=2c4ed59a&scoped=true&"
import script from "./half_loc_cards.vue?vue&type=script&lang=js&"
export * from "./half_loc_cards.vue?vue&type=script&lang=js&"
import style0 from "./half_loc_cards.vue?vue&type=style&index=0&id=2c4ed59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ed59a",
  null
  
)

export default component.exports